import React from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    MenuItem,
    Select,
    Slider,
    withStyles,
} from '@material-ui/core';
import { enabledField, valueText } from '../index';

const styles = (theme) => ({
    formControl: {
        width: '100%',
    },
});

const PresetMobileSettings = (props) => {
    const {
        classes,
        translations,
        values,
        methods,
        securazeSolutions,
        verify,
        handleChange,
        osType = 'Android',
        setFieldValue,
        skuPatterns,
    } = props;

    const fieldNames = {
        PrintUponConnection: `${osType}.PrintUponConnection`,
        PrintUponSuccessfulErasure: `${osType}.PrintUponSuccessfulErasure`,
        PrintUponFailedOrAbortedErasure: `${osType}.PrintUponFailedOrAbortedErasure`,
        PrintUponDiagnose: `${osType}.PrintUponDiagnose`,
        RemoveAppAfterDiagnose: `${osType}.RemoveAppAfterDiagnose`,
        ErasureAfterDiagnose: `${osType}.ErasureAfterDiagnose`,
        MethodMobile: `${osType}.MethodMobile`,
        TypeMobile: `${osType}.TypeMobile`,
        VerificationMobile: `${osType}.VerificationMobile`,
        CustomValueMobile: `${osType}.CustomValueMobile`,
        UserKPIEnabled: `${osType}.UserKPIEnabled`,
        UserKPICountDiagnosedDevices: `${osType}.UserKPICountDiagnosedDevices`,
        UserKPICountRegisteredDevices: `${osType}.UserKPICountRegisteredDevices`,
        SKUPatternID: `${osType}.SKUPatternID`,
    };

    const fieldValues = {
        PrintUponConnection: values[osType]['PrintUponConnection'],
        PrintUponSuccessfulErasure: values[osType]['PrintUponSuccessfulErasure'],
        PrintUponFailedOrAbortedErasure: values[osType]['PrintUponFailedOrAbortedErasure'],
        PrintUponDiagnose: values[osType]['PrintUponDiagnose'],
        RemoveAppAfterDiagnose: values[osType]['RemoveAppAfterDiagnose'],
        ErasureAfterDiagnose: values[osType]['ErasureAfterDiagnose'],
        MethodMobile: values[osType]['MethodMobile'],
        TypeMobile: values[osType]['TypeMobile'],
        VerificationMobile: values[osType]['VerificationMobile'],
        CustomValueMobile: values[osType]['CustomValueMobile'],
        UserKPIEnabled: values[osType]['UserKPIEnabled'],
        UserKPICountDiagnosedDevices: values[osType]['UserKPICountDiagnosedDevices'],
        UserKPICountRegisteredDevices: values[osType]['UserKPICountRegisteredDevices'],
        SKUPatternID: values[osType]['SKUPatternID'],
    };

    return (
        <>
            <FormControl className={classes.formControl} margin={'dense'}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={'dense'}
                                name={fieldNames['PrintUponConnection']}
                                checked={fieldValues['PrintUponConnection'] || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['print_upon_connection'] || 'Print upon connection'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={'dense'}
                                name={fieldNames['PrintUponSuccessfulErasure']}
                                checked={fieldValues['PrintUponSuccessfulErasure'] || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['print_upon_successful_erasure'] || 'Print upon successful erasure'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={'dense'}
                                name={fieldNames['PrintUponFailedOrAbortedErasure']}
                                checked={fieldValues['PrintUponFailedOrAbortedErasure'] || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${
                            translations['print_upon_failed_or_aborted_erasure'] ||
                            'Print upon failed or aborted erasure'
                        }`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={'dense'}
                                name={fieldNames['PrintUponDiagnose']}
                                checked={fieldValues['PrintUponDiagnose'] || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['print_upon_diagnose'] || 'Print upon diagnose'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={'dense'}
                                name={fieldNames['RemoveAppAfterDiagnose']}
                                checked={fieldValues['RemoveAppAfterDiagnose'] || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['remove_app_after_diagnose'] || 'Remove app after diagnose'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={'dense'}
                                name={fieldNames['ErasureAfterDiagnose']}
                                checked={fieldValues['ErasureAfterDiagnose'] || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['erasure_after_diagnose'] || 'Erasure after diagnose'}`}
                    />
                </FormGroup>
                {/* <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["UserKPIEnabled"]}
                                checked={(fieldValues["UserKPIEnabled"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['enabled'] || 'Enabled'}`}
                    />
                </FormGroup> */}
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={'dense'}
                                name={fieldNames['UserKPICountDiagnosedDevices']}
                                checked={fieldValues['UserKPICountDiagnosedDevices'] || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['count_diagnosed_devices'] || 'Count diagnosed devices'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={'dense'}
                                name={fieldNames['UserKPICountRegisteredDevices']}
                                checked={fieldValues['UserKPICountRegisteredDevices'] || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['count_registered_devices'] || 'Count registered devices'}`}
                    />
                </FormGroup>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['securaze_standard_mobile_text'] || 'Please select mobile securaze standard'}
                </InputLabel>
                <Select
                    name={fieldNames['MethodMobile']}
                    label={translations['wipe_method_mobile'] || 'Mobile Erasure method'}
                    margin={'dense'}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                    value={fieldValues['MethodMobile'] || ''}
                >
                    {(methods ? methods : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['securaze_solution_mobile_text'] || 'Please select mobile securaze solution'}
                </InputLabel>
                <Select
                    name={fieldNames['TypeMobile']}
                    label={translations['securaze_solution_mobile'] || 'Mobile securaze solution'}
                    margin={'dense'}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                    value={fieldValues['TypeMobile'] || ''}
                >
                    {(securazeSolutions ? securazeSolutions : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['wipe_verify_mobile_text'] || 'Please select mobile verify method'}
                </InputLabel>
                <Select
                    name={fieldNames['VerificationMobile']}
                    label={translations['VerificationMobile'] || 'Wipe verify mobile'}
                    margin={'dense'}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                    value={fieldValues['VerificationMobile'] || ''}
                >
                    {(verify ? verify : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {fieldValues['VerificationMobile'] === 'custom' ? (
                <>
                    <InputLabel shrink>
                        {translations['select_verification_percentage'] || 'Please select verification percentage'}
                    </InputLabel>
                    <Slider
                        name={fieldNames['CustomValueMobile']}
                        defaultValue={fieldValues['CustomValueMobile']}
                        valueLabelFormat={valueText}
                        onChange={(event, value) => setFieldValue(fieldNames['CustomValueMobile'], value)}
                        valueLabelDisplay="on"
                        aria-labelledby="discrete-slider"
                        step={1}
                        marks
                        min={0}
                        max={100}
                        disabled={enabledField(values)}
                    />{' '}
                </>
            ) : (
                <>
                    <br />{' '}
                </>
            )}
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['sku_select'] || 'Please select SKU pattern'}</InputLabel>
                <Select
                    name={fieldNames['SKUPatternID']}
                    value={fieldValues['SKUPatternID']}
                    label={translations['sku_pattern'] || 'SKU Pattern'}
                    margin={'dense'}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(skuPatterns ? skuPatterns : []).map((option) => (
                        <MenuItem key={option.SKUPatternID} value={option.SKUPatternID}>
                            {option.Name} - {option.Pattern}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
};

export default withStyles(styles, { withTheme: true })(PresetMobileSettings);
